/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsloaderror2Inputs */

const en_statsloaderror2 = /** @type {(inputs: Statsloaderror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These figures couldn't be loaded.`)
};

const de_statsloaderror2 = /** @type {(inputs: Statsloaderror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Zahlen konnten nicht geladen werden.`)
};

/**
* | output |
* | --- |
* | "These figures couldn't be loaded." |
*
* @param {Statsloaderror2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsloaderror2 = /** @type {((inputs?: Statsloaderror2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsloaderror2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsloaderror2(inputs)
	return de_statsloaderror2(inputs)
});
export { statsloaderror2 as "statsLoadError" }